import React from 'react';
import {
    Pagination,
    PaginationItem,
    PaginationLink
} from 'reactstrap';
import styles from './styles.module.scss';

export default function allPaginations({
    pageLink,
    currentPage,
    pagination }) {

    return (

        <Pagination size="md" aria-label="pagination" className={`${styles.root} d-flex justify-content-end`}>
            <PaginationItem disabled={currentPage.current === 1}>
                <PaginationLink previous href={`${pageLink}${currentPage.previous}/`} />
            </PaginationItem>
            {
                pagination.map((post) => (
                    <PaginationItem key={post.params.page} active={post.params.page == currentPage.current}>
                        <PaginationLink href={`${pageLink}${post.params.page}/`}>
                            {post.params.page}
                        </PaginationLink>
                    </PaginationItem>
                ))
            }
            <PaginationItem disabled={currentPage.next === null}>
                <PaginationLink next href={`${pageLink}${currentPage.next}/`} />
            </PaginationItem>
        </Pagination >
    )
}